import SVG from 'react-inlinesvg';
import cx from 'classnames';

import Tooltip, { TooltipDirection } from 'lib/Tooltip';

interface IconButtonProps {
  dataTestId?: string;
  icon: string;
  tooltipText: string;
  isDisabled?: boolean;
  onClick?: () => void;
  pendoId?: string;
}

const IconButton = ({
  dataTestId = '',
  icon,
  tooltipText,
  isDisabled = false,
  onClick = () => null,
  pendoId,
}: IconButtonProps): React.ReactElement => {
  return (
    <Tooltip tooltip={<p className="w-max">{tooltipText}</p>} direction={TooltipDirection.TOP} delay>
      <button
        data-test-id={dataTestId}
        data-pendo-id={pendoId}
        type="button"
        onClick={isDisabled ? undefined : onClick}
        className={cx(
          'p-1.5 text-primary-600 rounded-md bg-primary-600-opacity-5 hover:bg-primary-600-opacity-10 disabled:text-neutral-950-opacity-30 disabled:bg-neutral-950-opacity-5',
          { readOnly: isDisabled },
        )}
        disabled={isDisabled}
      >
        <SVG src={icon} className="h-4 w-4" />
      </button>
    </Tooltip>
  );
};

export default IconButton;
